import React, { useState } from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import "./TalentSearch.css";
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Form, Col, Row, Card, CardBody, Button } from "react-bootstrap";
import setting from "../../setting.json";
import { Link } from "react-router-dom";

function TalentSearchExamEligibility() {

    return (

        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold"> Talent Search Exam 2026</h1>
                </div>
            </header>

            <div className="container my-5">
                <div className="row">
                    <div className="col-lg-12 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
                        <h2  style={{ alignSelf: "center" }}>
                            Talent Search Exam 2026
                        </h2>
                        <h5 className="mb-4 mb-lg-5" style={{ alignSelf: "center" }} > Organised by : Dr Om Prakash Tripathi Foundation </h5>

                    </div>
                    <Row>
                        <Col lg={9}>
                            <Card >
                                <CardBody>
                                    <ul>
                                        <li><b>Application Date</b>: 26 January’2026 to 31 March 2026</li>
                                        <li><b className="title1">Application Fees</b>: Online or Offline –Rs 20/-Only </li>
                                        <li><b>Eligibility</b>: Intermediate with any stream Class 12 appear students only.</li>
                                        <li><b>Admit Cards</b>:  Admit cards will be available from 01-04-2026 to 04-04-2026 on college website(www.acmcollege.org). And also, available to “Acharya Chankya PGCollege”.</li>
                                        <li><b>Exam Schedule</b>: 05th April 2026 at 09:00 AM to 11:00 AM.</li>
                                         <li><b>Exam Center</b>: Acharya Chankya PG College, Mahmoodpur, Semeri Sultanpur</li>
                                        <li><b>Declaration of Result</b>: 20 April 2026 12:00AM at our college website (www.acmcollege.org)</li>
                                        <li><b>Award Distribution Programme </b>: 03 May 2026  (Sunday) </li>
                                        <li><b>Syllabus</b>: Syllabus as per Matriculation Level. MCQ based question.</li>

                                    </ul>

                                    <ul className="list2">
                                        <li>General Hindi& English 20 Marks</li>
                                        <li>General Knowledge & Current Affairs 20 Marks</li>
                                        <li>Mathematics & Reasoning 20 Marks</li>
                                        <li>Social Science 20 Marks</li>
                                        <li>General Science 20 Marks</li>
                                        <li><b>Total Marks 100 Marks</b></li>
                                        <li><b>Duration: 02 Hours</b></li> 

                                    </ul>
                                    <p><b>Helpline Number for technical support : 6394230457</b></p>                             
                                    <Link to="/talent-search-result"><Button variant="danger" className=" me-2 mt-4"> Check Result</Button></Link>
                                    <Link to="/talent-search-exam"><Button variant="success" className=" me-5 mt-4" >Apply Now</Button></Link>
                                    <Link to="/know-your-registration"><Button variant="info" className="me-2 mt-4">Know Your Registration</Button></Link>
                                           <Link to="/talent-search-admitcard"><Button variant="primary" className="d-flex justify-content-center mt-4" > Admit Card</Button></Link>
                                </CardBody >
                            </Card >
                        </Col >
                        <Col lg={3}>
                            {/* <p>Important Links</p>
                            <ul>
                                <li><Link to="/talent-search-exam">Talent Search Exam Form 2026</Link></li>
                                <li><Link to="/talent-search-admitcard">Talent Search Admit Card 2026</Link></li>
                                <li><Link to="/talent-search-result">Talent Search Result 2026</Link></li>
                                <li><Link to="/know-your-registration">Know Your Registration 2026</Link></li>
                            </ul> */}



                        </Col>
                    </Row >

                </div >
            </div >
            <Footer />
        </div >
    );
}

export default TalentSearchExamEligibility;
